import {Field} from 'formik';


import {
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>

            <PlatformFieldset legend={'Setup Intent Details'} variant={'filled'}>

                <Field
                    name='customerId'
                    label='Customer'
                    description='Please select the customer'
                    component={CustomersAutocomplete}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter description'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='paymentMethod'
                    label='Payment Method'
                    description='Please enter payment method ID'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='usage'
                    label='Usage'
                    description='Please select usage type'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'offSession',
                            label: 'Off Session'
                        },
                        {
                            value: 'onSession',
                            label: 'On Session'
                        },
                    ]}
                    my={'xl'}
                />


            </PlatformFieldset>

        </Stack>
    );
};
